import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import Moment from 'moment';

import SparklineGroup from '../../../../components/charts/sparklinegroup';

// refreshMode: 'debounce'
const ResponsiveSparklineGrid = ({
    metrics,
    height,
    width,
    start,
    end,
    settings,
    size,
    onClick,
    colors,
    ...grid
}) => {
    return (
        <Grid item { ...grid } style={{ width: '100%' }} >
            <SparklineGroup { ...{
                metrics,
                height,
                width,
                start,
                end: end || Moment().utc().toISOString(),
                settings,
                onClick,
                colors,
                key: 'widget'
            }} />
        </Grid>
    );
};
ResponsiveSparklineGrid.propTypes = {
    metrics: PropTypes.array,
    height: PropTypes.number,
    width: PropTypes.number,
    start: PropTypes.string,
    end: PropTypes.string,
    settings: PropTypes.object,
    onClick: PropTypes.func,
    colors: PropTypes.func,

    // provided by sizeMe
    size: PropTypes.object,
};

const CalcVisibleSeries = (h, margin, chartHeight) => {
    return Math.floor(Math.max(((h - margin) / chartHeight) || 0, 1));
};

export {
    ResponsiveSparklineGrid as default,
    CalcVisibleSeries,
};
